export const REACT_APP_API_KEY = "AIzaSyDvFGZrHg0TrjXCq_4PpyaySa3pMDnMSLo";
export const REACT_APP_AUTH_DOMAIN = "eyezon-business.firebaseapp.com";
export const REACT_APP_DATABASE_URL = "https://eyezon-business.firebaseio.com";
export const REACT_APP_PROJECT_ID = "eyezon-business";
export const REACT_APP_STORAGE_BUCKET = "eyezon-business.appspot.com";
export const REACT_APP_MESSAGING_SENDER_ID = "666370526556";
export const REACT_APP_APP_ID = "1:666370526556:web:b44c054c79a8d987af8599";
export const REACT_APP_PUBLIC_VAPID_KEY =
  "BB4_49lxHTVkrlYZGBMyryw_2Ldzs4_NwehCov01aalAFJyoiwCvRIqBLEDaQEqaZzT2KeStmnS-UYGrx4ZsTVs";
